<template><div class="home">
404 Page Not Found
</div></template>

<script>

export default {
	components: {},
	data: function() {
		return {

		}
	},
	methods: {

	},
	created: function () {

	}
}
</script>
